// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".platform[data-v-3d6f7e0a]{z-index:10}.platform .icon[data-v-3d6f7e0a]{height:2rem;width:2rem;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
